import { cn } from "@/lib/utils";
import logoIcon from "@/assets/ezyclass-icon.png";

type Props = {
  className?: string;
  /** Show on a dark background — wrap icon in a white tile so the navy book stays visible. */
  onDark?: boolean;
  /** Tailwind size class for the icon box, e.g. "size-9". */
  size?: string;
};

export function BrandLogo({ className, onDark = false, size = "size-9" }: Props) {
  if (onDark) {
    return (
      <div
        className={cn(
          size,
          "rounded-lg grid place-items-center bg-white shadow-sm shrink-0",
          className,
        )}
      >
        <img
          src={logoIcon}
          alt="Ezyclass management software logo"
          className="w-[78%] h-[78%] object-contain"
          loading="eager"
          decoding="async"
        />
      </div>
    );
  }
  return (
    <img
      src={logoIcon}
      alt="Ezyclass management software logo"
      className={cn(size, "object-contain shrink-0", className)}
      loading="eager"
      decoding="async"
    />
  );
}
